var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDashboardAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 33,
    viewBox: "0 0 63 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.474V0.111145H40.4535V8.24721C39.7589 8.3098 39.0827 8.43624 38.4309 8.62062V8.20185H2.02268V30.4513H38.4309V30.0325C39.0827 30.2169 39.7589 30.3433 40.4535 30.4059V32.474H0ZM38.4309 2.13382H2.02268V6.17918H38.4309V2.13382ZM10.0936 11.1174L11.9938 10.426L18.2199 27.5318L16.3197 28.2271L10.0936 11.1174ZM6.06803 16.2926V14.2699H8.09071V16.2926H6.06803ZM6.06803 24.3833V22.3606H8.09071V24.3833H6.06803Z",
    fill: "#0BB7A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.465 29.0607C39.5397 29.0607 37.6577 28.4898 36.057 27.4202C34.4562 26.3506 33.2086 24.8304 32.4718 23.0517C31.7351 21.273 31.5423 19.3158 31.9179 17.4276C32.2935 15.5393 33.2206 13.8049 34.5819 12.4435C35.9432 11.0822 37.6777 10.1551 39.5659 9.7795C41.4542 9.4039 43.4114 9.59667 45.1901 10.3334C46.9687 11.0702 48.489 12.3178 49.5586 13.9186C50.6282 15.5194 51.1991 17.4014 51.1991 19.3266C51.1962 21.9073 50.1697 24.3816 48.3448 26.2064C46.52 28.0313 44.0457 29.0578 41.465 29.0607ZM41.465 10.983C39.8148 10.983 38.2016 11.4724 36.8295 12.3892C35.4575 13.306 34.388 14.6091 33.7565 16.1337C33.125 17.6582 32.9598 19.3358 33.2817 20.9543C33.6037 22.5728 34.3983 24.0595 35.5652 25.2264C36.7321 26.3932 38.2187 27.1879 39.8372 27.5098C41.4557 27.8317 43.1333 27.6665 44.6579 27.035C46.1825 26.4035 47.4856 25.3341 48.4024 23.962C49.3192 22.5899 49.8085 20.9768 49.8085 19.3266C49.806 17.1145 48.9261 14.9938 47.362 13.4296C45.7978 11.8654 43.677 10.9856 41.465 10.983Z",
    fill: "#0BB7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4082 21.2715L39.3827 24.3833L46.5216 16.2926",
    stroke: "#0BB7A7",
    strokeWidth: 1.38698,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 13.2585H29.3287",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 18.3152H26.2947",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 23.3719H29.3287",
    stroke: "#0BB7A7",
    strokeWidth: 2.02268,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2494,
    height: 22.2494,
    fill: "white",
    transform: "translate(30.3402 8.20185)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDashboardAccepted);
export default __webpack_public_path__ + "static/media/rr_dashboard_accepted.d5079e4d28883e61886d8544f80beaaa.svg";
export { ForwardRef as ReactComponent };